<template>
  <!-- <div class="contents-list"> -->
    <draggable
       class="contents-list"
      :options="options.draggable"
      :class="{ 'is-draggable': edit }"
      v-model="items"
      @end="onEnd">

      <div v-for="item in items" :key="item.id" class="contents-list__item">
        <div class="contents-list__move">
          <a><i class="fal fa-arrows-v"></i></a>
        </div>

        <div class="contents-list__content">
          <div class="contents-list__content-quantity">
              <span class="content-quantity__clock">{{ item.weight_gr | number-format(2) }}g</span>
              <span class="content-quantity__space-before">
                  <span class="line"></span>
              </span>
              <span v-if="_get(item, 'ContentServingSize.code') === 'total_ingredients_quantity'" class="content-quantity__serving-size">{{ item.ContentServingSize.title || item.ContentServingSize.description }}</span>
              <span v-else-if="_get(item, 'ContentServingSize.symbol') !== 'g'" class="content-quantity__serving-size">{{ item.amount | number-format(2) }} {{ item.ContentServingSize.title || item.ContentServingSize.description }}</span>
              <span class="content-quantity__space-after">
                  <span class="line"></span>
              </span>
          </div>
          <div class="contents-list__content-description">
              <div class="content-description__icon">
                <nuttrema-iconica-kcal
                    :text="item.Content.name"
                    :image="getImagePath(item.Content)"
                    :nutrientDefinition="item.NutritionInfo">
                  </nuttrema-iconica-kcal>
              </div>
              <div class="content-description__information">
                <div class="content-description__text">
                  <div class="text--title">
                    <span>
                      <span class="span-ellipsis">{{ _get(item, 'Content.name') }}</span>
                    </span>
                  </div>
                  <div class="text--subtitle" v-if="_get(item, 'Content.EntityType.name')">
                    <span>
                      <span class="span-ellipsis">
                        {{ _get(item, 'Content.EntityType.name') }}<span v-if="_get(item, 'Content.Manufacturer.name')" v-html="_markdown.renderInline(', ' + $t('label.manufactured_by', { manufacturer: _get(item, 'Content.Manufacturer.name') }))"></span>
                      </span>
                    </span>
                  </div>
                </div>

                <!-- check permissions for food allergens -->
                <permissions-control-wrapper
                   tooltipPlacement="bottom"
                   action="permissions.subscribed_plan.food_allergens"
                  :clarification="false"
                  :permissions="_get(StuffToEatContents, 'meta.permissions')"
                  :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.FOOD_ALLERGENS">
                  <div slot="allowed" class="contents-description__allergens">
                    <nuttrema-allergens-info :allergens="_get(item, 'Allergens')"></nuttrema-allergens-info>
                  </div>
                </permissions-control-wrapper>
                <!-- check permissions for food allergens -->

                <div class="contents-description__nutritions-stucture">
                  <nuttrema-nutritions-stucture-bars
                    :nutritions="item.NutritionInfo">
                  </nuttrema-nutritions-stucture-bars>
                </div>
                <div v-if="edit" class="contents-description__action">
                  <router-link
                     tag="a"
                     activeClass="is-active"
                     class="el-button el-button--text el-button--list-item"
                    :to="{
                      name: meta.navigation.edit,
                      params: {
                        entityContentID: item.id,
                      },
                      query: {
                        contentID: item.Content.id,
                        contentType: STUFF_TO_EAT_KEYS[item.Content.EntityType.code],
                      },
                    }">
                    {{ $t('label.edit') }} <i class="el-icon-arrow-right"></i>
                  </router-link>
                </div>
              </div>
          </div>
        </div>
      </div>

      <div v-if="note" class="contents-list__item">
        <div class="contents-list__move"></div>
        <div class="contents-list__content">

          <div class="contents-list__content-quantity">
            <span class="content-quantity__clock">&nbsp;</span>
            <span class="content-quantity__space-before">
                <span class="line"></span>
            </span>
            <span class="content-quantity__space-after">
                <span class="line"></span>
            </span>
          </div>

          <div class="contents-list__content-description">
            <div class="content-description__icon"></div>

            <div class="content-description__information">
                <div class="content-description__text">
                  <el-alert
                    show-icon
                    type="warning"
                    :title="note.split('.').length - 1 > 1 ? $t('label.notes') : $t('label.note')">
                    <p class="el-alert__description" v-html="_markdown.render(note)"></p>
                  </el-alert>
                </div>
            </div>
          </div>
        </div>
      </div>

    </draggable>
  <!-- </div> -->
</template>

<script>
/* eslint-disable object-shorthand */
import { each, isEmpty, cloneDeep } from 'lodash';
import { STUFF_TO_EAT_KEYS } from 'constants/types';

import draggable from 'vuedraggable';

import NuttremaIconicaKcal from 'components/ui/label/nuttrema-iconica-kcal';
import NuttremaNutritionsStuctureBars from 'components/ui/label/nuttrema-nutritions-stucture-bars';

import NuttremaAllergensInfo from 'components/ui/allergens/nuttrema-allergens-info';

export default {
  name: 'cmpt-contents-list',
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    StuffToEatContents: {
      type: Object,
      required: true,
      default: null,
    },
    meta: {
      required: true,
    },
    note: {
      required: false,
    },
  },
  data() {
    return {
      STUFF_TO_EAT_KEYS,
      options: {
        draggable: {
          disabled: true,
        },
      },
      items: [],
    };
  },
  components: {
    draggable,
    NuttremaIconicaKcal,
    NuttremaAllergensInfo,
    NuttremaNutritionsStuctureBars,
  },
  methods: {
    toggleWest() {
      this.$emit('toggleWest');
    },
    onEnd() {
      const sequence = [];

      each(this.items, (item, index) => {
        sequence.push({ id: item.id, seq: index });
      });

      console.log('sorted', this.items, sequence);
      this.$emit('edit', sequence);
    },
    getImagePath(item) {
      return !isEmpty(item.Image) ? `${process.env.IMAGES_ROOT}${item.Image.path}${item.Image.thumbnails.medium.filename}` : null;
    },
  },
  watch: {
    StuffToEatContents: {
      handler: function (values) {
        console.log('changed StuffToEatContents');
        this.items = cloneDeep(values.data);
      },
      deep: true,
    },
    edit(newValue) {
      this.options.draggable.disabled = !newValue;
    },
  },
  created() {
    this.items = cloneDeep(this.StuffToEatContents.data);
    this.options.draggable.disabled = !this.edit;
  },
};
</script>

<style lang="scss" scoped>
@import '~assets/styles/theme/colors';
$help-color: #555;

.line {
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
  &:before {
    display: inline-block;
    width: 100%;
    height: 100%;
    top: -50%;
    left: 0;
    content: ' ';
    position: absolute;
    border-bottom: 1px solid $state-info-bg;
  }
  &.dotted:before {
    border-bottom: 1px dotted $state-info-bg;
  }
}

.span-ellipsis {
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  text-overflow: ellipsis;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.contents-list {
  flex-grow: 1;
  display: flex;
  position: relative;
  align-self: stretch;
  flex-direction: column;

  .contents-list__item {
    z-index: 1;
    display: flex;
    flex-shrink: 0;
    align-self: stretch;
    padding-bottom: 1.5em;

    .contents-list__move {
      flex: 0 0 2em;
      display: flex;
      align-self: stretch;
      align-items: center;
      justify-content: flex-end;
      > * {
        display: none;
        transition: all 0.15s linear;
        align-self: center;
        font-size: 1.5rem;
        color: rgba($help-color, 0.25);
        &:hover {
          color: rgba($help-color, 0.75);
        }
      }
    }

    .contents-list__content {
      display: flex;
      flex-grow: 1;
      align-self: stretch;
      flex-direction: column;

      .contents-list__content-quantity {
        display: flex;
        flex-grow: 1;
        flex-wrap: wrap;
        align-self: stretch;
        align-items: center;
        justify-content: space-between;
        .content-quantity__clock {
          flex: 0 0 5em;
          min-width: 5em;
          font-weight: 800;
          text-align: right;
          padding-right: 0.5em;
        }
        .content-quantity__space-before {
          flex: 0 0 5em;
          min-width: 5em;
          position: relative;
          padding-left: 0.75em;
        }
        .content-quantity__space-after {
          flex-grow: 1;
          position: relative;
        }
        .content-quantity__serving-size {
          padding: 0 0.75em;
          font-weight: 500;
        }
      }
      // end ~ contents-list__content-quantity

      .contents-list__content-description {
        display: flex;
        flex-grow: 1;
        align-self: stretch;

        .content-description__icon {
          width: 4.5em;
          flex: 0 0 4.5em;
          min-width: 4.5em;
          text-align: center;
          margin-left: 5.75em;
          margin-right: 0.5em;
          > * {
            display: inline-block;
          }
        }

        .content-description__information {
          flex-grow: 1;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .content-description__text {
            width: 50%;
            min-width: 15%;

            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-right: 1.5em;

            .text--title,
            .text--subtitle {
              display: flex;
              align-self: stretch;
              position: relative;
              > span {
                height: 1.5em;
                display: flex;
              }
            }

            .text--title {
              > span {
                font-weight: 500;
              }
            }

            .text--subtitle {
              > span {
                height: 1.35em;
                font-size: 0.95rem;
                color: $gray-light;
              }
            }
          }
          .contents-description__allergens,
          .contents-description__nutritions-stucture,
          .contents-description__action {
            display: flex;
            flex-shrink: 0;
            position: relative;
            margin-right: 1.5em;
            flex-direction: column;
            justify-content: center;
          }
        }
      }
    }
    // end ~ contents-list__content
  }
  // end ~ contents-list__item

  &.is-draggable {
    .contents-list__move {
      > * {
        opacity: 1;
        display: flex;
      }
    }
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
  .nuttrema-layout-schedules__central.west-expanded,
  .nuttrema-layout-default-slide.is-expanded {
    .contents-list {
      .content-description__information {
        flex-wrap: wrap;
        flex-direction: column;
        > * {
          flex-grow: 1;
          align-self: stretch;
          margin-bottom: 0.5em;
        }
        .content-description__text {
          margin-top: 0.5em;
          width: inherit !important;
        }
        .contents-description__action {
          a {
            padding-left: 0;
            text-align: left;
            width: 10em;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/contents/cmpt-contents-list.vue